import { makeAutoObservable, reaction } from "mobx";
import { ServerError } from "../models/serverError";

export default class CommonStore {
  error: ServerError | null = null;
  token: string | null = localStorage.getItem("jwt");
  appLoaded = false;
  uiBlocked = false;
  isMobileDevice = false;

  constructor() {
    makeAutoObservable(this);

    reaction(
      () => this.token,
      (token) => {
        if (token) {
          localStorage.setItem("jwt", token);
        } else {
          localStorage.removeItem("jwt");
        }
      }
    );
  }

  setServerError(error: ServerError) {
    this.error = error;
  }

  setToken = (token: string | null) => {
    this.token = token;
  };

  setAppLoaded = () => {
    this.appLoaded = true;
  };

  setUiBlocked = (bool: boolean) => {
    this.uiBlocked = bool;
  };

  checkAndSetIsMobile = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    this.isMobileDevice = /mobile|android|iphone|ipad|phone/i.test(userAgent);
  };
}
